/**
 * Метадані hero-секції для сторінки категорії курсів: зображення та фон.
 * Використовується в CoursesHeroSection та може бути перевикористано в інших місцях.
 */
export interface CourseCategoryHeroMeta {
  image: string
  background: string
  /** Фонове зображення — картинка на весь фон */
  backgroundImage?: string
  /** Фонове зображення для мобільних (max-width: 768px) */
  backgroundImageMobile?: string
  /** Зміщення фону по Y (опційно): напр. "30%", "20px", "top" */
  backgroundPositionY?: string
}

const BASE = '/assets/images/course-category'
const CATEGORY_MOBILE_BASE = '/assets/images/category'

export const COURSE_CATEGORY_HERO_META: Record<string, CourseCategoryHeroMeta> = {
  biblical: {
    image: `${BASE}/bibliyni-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/bible.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/biblical-mobile.jpg`,
  },
  family: {
    image: `${BASE}/simeyni-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/simeyni-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/family-mobile.jpg`,
  },
  health: {
    image: `${BASE}/zdorovya-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/zdorovya-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/health-mobile.jpg`,
    backgroundPositionY: '70%',
  },
  women: {
    image: `${BASE}/zhinochi-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/zhinochi-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/womens-mobile.jpg`,
  },
  womens: {
    image: `${BASE}/zhinochi-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/zhinochi-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/womens-mobile.jpg`,
  },
  youth: {
    image: `${BASE}/molodizhni-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/molodizhni-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/youth-mobile.jpg`,
  },
  teenage: {
    image: `${BASE}/pidlitky-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/pidlitky-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/teenage-mobile.jpg`,
  },
  kids: {
    image: `${BASE}/dity-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/dity-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/childish-mobile.jpg`,
  },
  childish: {
    image: `${BASE}/dity-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/dity-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/childish-mobile.jpg`,
  },
  psychology: {
    image: `${BASE}/psykholohiya-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/psykholohiya-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/psychology-mobile.jpg`,
  },
  prayer: {
    image: `${BASE}/molitva-hero.jpg`,
    background: 'transparent',
    backgroundImage: `${BASE}/molitva-hero.jpg`,
    backgroundImageMobile: `${CATEGORY_MOBILE_BASE}/prayer-mobile.jpg`,
  },
}

export const DEFAULT_COURSE_CATEGORY_HERO = 'biblical' as const
